import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeamCredsEditModule from "../comp/team-cred-edit";

export default function TeamEdit() {

  return (
    <>
      <HeaderInner name={'Edit Student'} link={'/bz/team'}/>
      <ViewContentSmall 
        content={
          <>
            <ViewDividerSmall />
            <TeamCredsEditModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}